
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

interface AdminAccount {
  id: string;
  adminName: string;
  instanceName: string;
  domain: string;
  userCount: number;
  status: string;
  createdAt: Date;
}

interface AdminAccountsTableProps {
  accounts: AdminAccount[];
}

const AdminAccountsTable: React.FC<AdminAccountsTableProps> = ({ accounts }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Admin Accounts Overview</CardTitle>
        <CardDescription>
          View all admin accounts under your reseller plan
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Admin Name</TableHead>
                <TableHead>Instance</TableHead>
                <TableHead>Domain</TableHead>
                <TableHead>Users</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Created</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {accounts.map((instance) => (
                <TableRow key={instance.id} className="border-b hover:bg-muted/20">
                  <TableCell className="font-medium">{instance.adminName}</TableCell>
                  <TableCell>{instance.instanceName}</TableCell>
                  <TableCell className="text-blue-600">{instance.domain}</TableCell>
                  <TableCell>{instance.userCount.toLocaleString()}</TableCell>
                  <TableCell>
                    <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                      Active
                    </span>
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {instance.createdAt.toLocaleDateString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdminAccountsTable;
